import { callApi } from '@/api/api.config';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

const BASE = 'carbon';

const markFarmAsComplete = async (id: string) => {
  return await callApi({
    method: 'POST',
    url: `${BASE}/mark_farm_as_complete/${id}/`,
  });
};

export const useMarkFarmAsComplete = () =>
  useMutation({
    mutationFn: (id: string) => markFarmAsComplete(id),
  });

const markProjectAsComplete = async (id: string) => {
  return await callApi({
    method: 'POST',
    url: `${BASE}/mark_project_as_complete/${id}/`,
  });
};

export const useMarkProjectAsComplete = () =>
  useMutation({
    mutationFn: (id: string) => markProjectAsComplete(id),
  });

const downloadCsv = async ({
  farmId,
  projectId,
  template,
}: {
  farmId?: string;
  projectId?: string;
  template?: string;
}): Promise<AxiosResponse<Blob, Record<string, string>>> => {
  const response = await callApi({
    method: 'GET',
    url: `${BASE}/download_csv/`,
    params: {
      farm_id: farmId,
      project_id: projectId,
      template,
    },
    responseType: 'blob',
  });

  return response;
};

export const useDownloadCsv = () =>
  useMutation({
    mutationFn: ({ farmId, projectId, template }: { farmId?: string; projectId?: string; template?: string }) =>
      downloadCsv({ farmId, projectId, template }),
  });
